module.exports = __webpack_public_path__ + "media/images/logo-ruuun-914c0fd1a6287080cc38499ce1ea2a9a.svg";